import { Activity } from "@mapmycustomers/shared/types/entity";

const getEmailLogRecipientName = (activity: Activity): string => {
  const [recipient] = activity.emailLog!.recipientAddress;
  return recipient.name || recipient.email;
};

export default getEmailLogRecipientName;
